import {createSlice} from '@reduxjs/toolkit'
import { removeReference } from '../../utils/Reusables'

const initialState = {
    list:[]
}

const breadcrumbSlice = createSlice({
    name:'breadcrumb',
    initialState,
    reducers:{
        addElement(state,action){
            let newObj = action.payload
            let obj = removeReference(state)
            let index = obj.list.findIndex(elem => elem.key == newObj.key)
            if(index < 0){
                obj.list.push(newObj)
            }
            return obj
        },
        removeElement(state,action){
            let newObj = action.payload
            //console.log('Remove',newObj)
            let obj = removeReference(state)
            let index = obj.list.findIndex(elem => elem.key == newObj.key)
            if(index > -1){
                obj.list = obj.list.slice(0,index+1)
            }
            return obj
        },
        removeAll(state,action){
            //console.log('Remove All')
            return initialState
        }
    }
})

export const breadcrumbActions = breadcrumbSlice.actions

export default breadcrumbSlice.reducer